var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vx-col", attrs: { id: "coupon-list" } },
    [
      _c(
        "vs-alert",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.apiErrors.length,
              expression: "apiErrors.length"
            }
          ],
          staticClass: "mb-3",
          attrs: { color: "danger", icon: "new_releases" }
        },
        [_c("small", [_vm._v(_vm._s(_vm.apiErrors[0]))])]
      ),
      _vm._v(" "),
      _vm.isAvailable
        ? _c(
            "div",
            { staticClass: "mb-base w-full" },
            [
              _c("h5", { staticClass: "mb-3" }, [
                _vm._v(_vm._s(_vm.capitalize(_vm.$t("coupon.available"))))
              ]),
              _vm._v(" "),
              _c("vs-divider"),
              _vm._v(" "),
              _vm.countRecordIf(_vm.couponList, "is_valid") > 0
                ? _c(
                    "div",
                    { staticClass: "vx-row" },
                    [
                      _vm._l(_vm.couponList, function(coupon, index) {
                        return [
                          coupon.is_valid
                            ? _c(
                                "div",
                                {
                                  key: "is_available_coupons_" + index,
                                  staticClass: "vx-col w-full lg:w-1/2 mb-2"
                                },
                                [
                                  _c(
                                    "vx-card",
                                    [
                                      _c("table", { staticClass: "w-full" }, [
                                        _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticClass: "text-center",
                                              attrs: { width: "30%" }
                                            },
                                            [
                                              _c("vs-avatar", {
                                                attrs: {
                                                  size: "large",
                                                  color: "success",
                                                  "icon-pack": "feather",
                                                  icon: "icon-tag"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "font-bold text-xl"
                                              },
                                              [
                                                _c(
                                                  "i18n",
                                                  {
                                                    attrs: {
                                                      path: "coupon.offAmount",
                                                      tag: "label"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.renderCurrency(
                                                            coupon.amount,
                                                            coupon.country
                                                              .currency
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("coupon.anyOrder")
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("coupon.expiredAt")
                                                  ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.renderDateFormat(
                                                        coupon.expired_date
                                                      )
                                                    )
                                                )
                                              ])
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _vm.isOnClickApplyCoupon
                                        ? _c("template", { slot: "footer" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex justify-between flex-wrap"
                                              },
                                              [
                                                _c("span", [_vm._v(" ")]),
                                                _vm._v(" "),
                                                _c(
                                                  "vs-button",
                                                  {
                                                    attrs: {
                                                      size: "small",
                                                      type: "filled"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.onClickApplyCoupon(
                                                          coupon
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.$t("action.apply")
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                : _c("div", { staticClass: "text-center" }, [
                    _c("i", [
                      _vm._v(
                        "--- " +
                          _vm._s(
                            _vm.$t("general.notAvailable", {
                              msg: _vm.$t("attribute.coupon")
                            })
                          ) +
                          " ---"
                      )
                    ])
                  ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isApplied
        ? _c(
            "div",
            { staticClass: "mb-base w-full" },
            [
              _c("h5", { staticClass: "mb-3" }, [
                _vm._v(_vm._s(_vm.capitalize(_vm.$t("coupon.used"))))
              ]),
              _vm._v(" "),
              _c("vs-divider"),
              _vm._v(" "),
              _vm.countRecordIf(_vm.couponList, "is_applied") > 0
                ? _c(
                    "div",
                    { staticClass: "vx-row" },
                    [
                      _vm._l(_vm.couponList, function(coupon, index) {
                        return [
                          coupon.is_applied
                            ? _c(
                                "div",
                                {
                                  key: "is_applied_coupons_" + index,
                                  staticClass: "vx-col w-full lg:w-1/2 mb-2"
                                },
                                [
                                  _c("vx-card", [
                                    _c("table", { staticClass: "w-full" }, [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-center",
                                            attrs: { width: "30%" }
                                          },
                                          [
                                            _c("vs-avatar", {
                                              attrs: {
                                                size: "large",
                                                color: "smoke",
                                                "icon-pack": "feather",
                                                icon: "icon-tag"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "font-bold text-xl"
                                            },
                                            [
                                              _c(
                                                "i18n",
                                                {
                                                  attrs: {
                                                    path: "coupon.offAmount",
                                                    tag: "label"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.renderCurrency(
                                                          coupon.amount,
                                                          coupon.country
                                                            .currency
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "mb-2" }, [
                                            _vm._v(
                                              _vm._s(_vm.$t("coupon.anyOrder"))
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c("small", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("coupon.expiredAt")
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.renderDateFormat(
                                                      coupon.expired_date
                                                    )
                                                  )
                                              )
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                : _c("div", { staticClass: "text-center" }, [
                    _c("i", [
                      _vm._v(
                        "--- " +
                          _vm._s(
                            _vm.$t("general.notAvailable", {
                              msg: _vm.$t("attribute.coupon")
                            })
                          ) +
                          " ---"
                      )
                    ])
                  ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isExpired
        ? _c(
            "div",
            { staticClass: "mb-base w-full" },
            [
              _c("h5", { staticClass: "mb-3" }, [
                _vm._v(_vm._s(_vm.capitalize(_vm.$t("coupon.expired"))))
              ]),
              _vm._v(" "),
              _c("vs-divider"),
              _vm._v(" "),
              _vm.countRecordIf(_vm.couponList, "is_expired") > 0
                ? _c(
                    "div",
                    { staticClass: "vx-row" },
                    [
                      _vm._l(_vm.couponList, function(coupon, index) {
                        return [
                          coupon.is_expired
                            ? _c(
                                "div",
                                {
                                  key: "is_expired_coupons_" + index,
                                  staticClass: "vx-col w-full lg:w-1/2 mb-2"
                                },
                                [
                                  _c("vx-card", [
                                    _c("table", { staticClass: "w-full" }, [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-center",
                                            attrs: { width: "30%" }
                                          },
                                          [
                                            _c("vs-avatar", {
                                              attrs: {
                                                size: "large",
                                                color: "danger",
                                                "icon-pack": "feather",
                                                icon: "icon-tag"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "font-bold text-xl"
                                            },
                                            [
                                              _c(
                                                "i18n",
                                                {
                                                  attrs: {
                                                    path: "coupon.offAmount",
                                                    tag: "label"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.renderCurrency(
                                                          coupon.amount,
                                                          coupon.country
                                                            .currency
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "mb-2" }, [
                                            _vm._v(
                                              _vm._s(_vm.$t("coupon.anyOrder"))
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c("small", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("coupon.expiredAt")
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.renderDateFormat(
                                                      coupon.expired_date
                                                    )
                                                  )
                                              )
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                : _c("div", { staticClass: "text-center" }, [
                    _c("i", [
                      _vm._v(
                        "--- " +
                          _vm._s(
                            _vm.$t("general.notAvailable", {
                              msg: _vm.$t("attribute.coupon")
                            })
                          ) +
                          " ---"
                      )
                    ])
                  ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("vs-pagination", {
        attrs: { total: _vm.pagination.last_page, max: 6 },
        on: {
          input: function(value) {
            return _vm.onPaginateTransaction(value)
          }
        },
        model: {
          value: _vm.pagination.current_page,
          callback: function($$v) {
            _vm.$set(_vm.pagination, "current_page", $$v)
          },
          expression: "pagination.current_page"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }